import { render } from "./ProductAddImageComponent.vue?vue&type=template&id=2229f475&scoped=true"
import script from "./ProductAddImageComponent.vue?vue&type=script&lang=js"
export * from "./ProductAddImageComponent.vue?vue&type=script&lang=js"

import "./ProductAddImageComponent.vue?vue&type=style&index=0&id=2229f475&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\_FINISHED PROJECTS\\photographer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2229f475"]])

export default __exports__